<template>
  <section class="hero">
    <!-- Картинка идёт первой в разметке: на мобильном она лежит под карточкой,
         поэтому карточка должна рисоваться после неё. На десктопе порядок
         задаётся правилами order. -->
    <div class="hero__media">
      <picture>
        <source
          media="(min-width: 768px)"
          :srcset="`${heroDesktop} 1x, ${heroDesktop2x} 2x`"
        />
        <img
          class="hero__image"
          :src="heroMobile"
          :srcset="`${heroMobile} 1x, ${heroMobile2x} 2x`"
          alt=""
        />
      </picture>
    </div>
    <div class="hero__card">
      <div class="hero__bento">
        <div class="hero__text">
          <h1 class="hero__title">вызов принят</h1>
          <p class="hero__subtitle">
            Меняйте правила и&nbsp;участвуйте в&nbsp;телеком кейс-чемпионате
          </p>
        </div>
        <div class="hero__action">
          <p class="hero__deadline">
            <img
              class="hero__deadline-icon"
              :src="iconCalendar"
              alt=""
              width="32"
              height="32"
            />
            <span
              >Регистрация с&nbsp;24.09.2026&nbsp;г.
              до&nbsp;14.10.2026&nbsp;г.</span
            >
          </p>
          <Button type="white" :to="REGISTRATION_URL">подать заявку</Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Button from "@/components/Button.vue";
import { REGISTRATION_URL } from "@/constants";
import heroDesktop from "@/assets/case-championship/hero-desktop.webp";
import heroDesktop2x from "@/assets/case-championship/hero-desktop@2x.webp";
import heroMobile from "@/assets/case-championship/hero-mobile.webp";
import heroMobile2x from "@/assets/case-championship/hero-mobile@2x.webp";
import iconCalendar from "@/assets/case-championship/icon-calendar.svg";
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 470px;
  padding: 8px;
  // На мобильном под карточкой лежит градиентная подложка, поверх которой
  // выводится картинка — она обрезается по скруглению баннера.
  background: linear-gradient(90deg, #e3e3e3 0%, #f3f3f3 100%);
  border-radius: var(--radiusOuter);
  overflow: clip;

  @include md {
    flex-direction: row;
    align-items: stretch;
    // В макете баннер 1312×360: высоту задаёт логотип-карточка, поэтому
    // растягиваем обе половины до 360px.
    min-height: 360px;
    padding: 0;
    background: #dadada;
  }

  &__media {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    // На всю ширину баннера: при экране шире 360px фиксированные 336px
    // оставляли по краям полосы фона секции.
    width: 100%;
    height: 496px;
    background: #dadada;
    overflow: clip;

    @include md {
      position: relative;
      left: auto;
      transform: none;
      order: 2;
      flex: 1 1 50%;
      min-width: 1px;
      width: auto;
      height: auto;
    }

    picture {
      display: contents;
    }
  }

  &__image {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    // Кадр тянется по ширине блока: по краям не остаётся полос подложки,
    // по высоте сохраняется макетное кадрирование (305px).
    width: 100%;
    height: 305px;
    max-width: none;
    object-fit: cover;

    @include md {
      top: 0;
      left: 0;
      transform: none;
      width: 100%;
      height: 100%;
      // Высота всегда 100% — кадр заполняет половину баннера без полей.
      object-fit: cover;
    }
  }

  &__card {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @include md {
      order: 1;
      flex: 1 1 50%;
      min-width: 1px;
      padding: 24px;
    }
  }

  &__bento {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 12px;
    background: var(--colorBlack);
    border-radius: var(--radiusInner);

    @include md {
      flex: 1 1 auto;
      justify-content: space-between;
      gap: 16px;
      padding: 24px;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @include md {
      gap: 16px;
    }
  }

  &__title {
    color: var(--colorWhite);
    font-size: var(--sizeHeading2);
    line-height: 26px;

    @include md {
      font-size: var(--sizeHeading1);
      line-height: 40px;
    }
  }

  &__subtitle {
    color: var(--colorWhite);
    font-size: var(--sizeText);
    line-height: var(--lineHeightText);
  }

  &__action {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @include md {
      gap: 16px;
    }
  }

  &__deadline {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--colorWhite);
    font-size: var(--sizeText);
    line-height: var(--lineHeightText);
  }

  &__deadline-icon {
    flex-shrink: 0;
  }
}
</style>
